module.exports = __webpack_public_path__ + "img/moving_truck.d8c6db33.svg";